import { PageEvents } from '@griply/types';
import React from 'react';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';

import { MobileAddLifeAreaButton } from './components/mobile-add-life-area-button';
import { Overview } from './components/overview';
import { PageTopBar } from './components/page-top-bar';
import * as Styled from './life-area-overview.style';

export const LifeAreaOverview: React.FC = () => {
  useTrackPageVisitEvent(PageEvents.LifeAreas, undefined);

  return (
    <Styled.Container>
      <Styled.Main>
        <Styled.MainContent>
          <PageTopBar />

          <Overview />

          <MobileAddLifeAreaButton />
        </Styled.MainContent>
      </Styled.Main>
    </Styled.Container>
  );
};
